import DogListingPage from "@dogstrust/uk/staticPageTemplates/DogListingPage/DogListingPage";
export { Head } from "@dogstrust/uk/staticPageTemplates/DogListingPage/DogListingPage";

import { graphql } from "gatsby";
import React from "react";

export interface DogIndexPageProps {
	data: Queries.DogListingPageQuery;
}

const RehomingListingPage: React.FC<DogIndexPageProps> = ({ data }) => (
	<DogListingPage data={data} />
);

export default RehomingListingPage;

export const query = graphql`
    query DogListingPage {
        allNodeCentre {
            nodes {
                ...RehomingCentreData
            }
        }
        pageData: nodeStaticInternalPageReference(
            field_link: { uri: { eq: "/rehoming/dogs" } }
        ) {
            ...StaticPageData
        }
    }
`;
